import React from 'react';
import styled from 'styled-components';
import { semanticColors } from '@/common/styles/colorTokens';
import { Step, StepItemType } from '@/common/components/step/Step';

interface InvitationLayoutProps {
  children: React.ReactNode;
  maxWidth?: string;
  showSteps?: boolean;
  steps?: StepItemType[];
}

export const InvitationLayout: React.FC<InvitationLayoutProps> = ({
  children,
  maxWidth = '600px',
  showSteps = false,
  steps = []
}) => {
  return (
    <Container>
      {showSteps && steps.length > 0 && (
        <StepWrapper>
          <Step steps={steps} direction="vertical" />
        </StepWrapper>
      )}
      <ContentWrapper $maxWidth={maxWidth}>
        {children}
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  height: 100vh;
  background: ${semanticColors.background.primary};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 2rem 1rem;
  overflow-y: auto;
`;

const ContentWrapper = styled.div<{ $maxWidth: string }>`
  width: 100%;
  max-width: ${props => props.$maxWidth};
`;

const StepWrapper = styled.div`
  padding: 2rem 2rem 0 2rem;
`; 